import {BankTransactionImportResponse} from "@/types/service-response";
import BankTransaction from "@/model/BankTransaction/BankTransaction";

 export default class BankTransactionImport {
     private constructor(
         readonly duplicateCount: number,
         readonly importedCount: number,
         readonly processedCount: number,
         readonly transactions: BankTransaction []
     ) {}

     static createFromResponse(responseData : BankTransactionImportResponse): BankTransactionImport {

        return new BankTransactionImport(
            responseData.duplicateCount,
            responseData.importedCount,
            responseData.processedCount,
            BankTransaction.createFromResponseList(responseData.transactions),
        )
    }
 }